import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Subject } from 'rxjs/Subject';
import { Observable } from '../../../../node_modules/rxjs';
import { GeneralHelper } from 'helpers/general.helper';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private emptyErrorContext: any = {
    message: '',
    location: ''
  };
  private nextErrorContext: any;

  constructor( private injector: Injector ) {

  }

// {
//   "status_code": // integer,
//     "reason_phrase": // string,
//   "errors": [
//     {
//       "errorCode": // string,
//         "message": // string
//     },
//     {...},
//     {...}
//     ]
// }
// {
//   "error": // String
//   "error_description": // String
// }


  handleError(error: any) {
    const locationStrategy = this.injector.get( LocationStrategy );
    if (error instanceof Error) {
      return Observable.throw(error);
    } else {
      this.nextErrorContext = {
        message: GeneralHelper.extractErrorMessage(error),
        location: locationStrategy instanceof PathLocationStrategy ? locationStrategy.path() : ''
      };
      return Observable.throw(this.nextErrorContext);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/helpers/services/error-handler.service.ts